import {
  EntityIconBase,
  type EntityIconAppearance,
  type EntityIconDensity,
} from './entity-icon-base';
import { ComputerIcon } from '@terra/ui-icons';

type IconWebPageProps = {
  appearance?: EntityIconAppearance;
  density?: EntityIconDensity;
};

export function IconWebPage({ appearance, density }: IconWebPageProps) {
  return (
    <EntityIconBase
      icon={ComputerIcon}
      bg="bg.entity.assets"
      color="fg.entity.assets"
      borderColor="border.entity.assets"
      appearance={appearance}
      density={density}
    />
  );
}
